import { Users, SprayCan, CreditCard, ChevronDown } from "lucide-react";
import { ENTRY_GROUPS } from "./entryHelpers";

const ICONS = { personel: Users, ekstra: SprayCan, atm: CreditCard };

// Hizmet Veri Girişi üst menüsü: 3 yan yana kutu (Personel / Ekstra Temizlik / ATM Silim) — seçilince altında 1. Adım (proje) açılır; only: yalnız verilen türler (ör. taşeron → atm)
export default function EntryGroupPicker({ value, onChange, counts, only }) {
  const groups = only ? ENTRY_GROUPS.filter((g) => only.includes(g.key)) : ENTRY_GROUPS;
  return (
    <div className="space-y-2">
      <div className={`grid grid-cols-1 gap-4 ${groups.length >= 3 ? "md:grid-cols-3" : groups.length === 2 ? "md:grid-cols-2" : ""}`} role="tablist" data-testid="entry-group-picker">
        {groups.map((g) => {
          const Icon = ICONS[g.key];
          const on = value === g.key;
          return (
            <button type="button" key={g.key} role="tab" aria-selected={on} onClick={() => onChange(g.key)} data-testid={`entry-group-${g.key}`}
              className={`relative text-left rounded-xl border-2 p-5 transition-all duration-200 ${on ? "border-sky-600 bg-sky-50 shadow-md ring-2 ring-sky-200" : "border-slate-200 bg-white hover:border-sky-300 hover:shadow-sm hover:-translate-y-0.5"}`}>
              <div className="flex items-start gap-3">
                <span className={`w-11 h-11 rounded-lg flex items-center justify-center shrink-0 transition-colors ${on ? "bg-sky-700 text-white" : "bg-slate-100 text-slate-700"}`}><Icon className="w-6 h-6" /></span>
                <div className="min-w-0">
                  <div className="font-bold text-slate-900 text-base leading-tight">{g.title}</div>
                  <div className="text-xs text-slate-500 mt-1">{g.desc}</div>
                  {counts?.[g.key] != null && <div className="text-[11px] font-semibold text-slate-600 mt-2" data-testid={`entry-group-count-${g.key}`}>{counts[g.key]} kayıt</div>}
                </div>
              </div>
              {on && <ChevronDown className="absolute -bottom-3 left-1/2 -translate-x-1/2 w-6 h-6 text-sky-600 bg-white rounded-full" />}
            </button>
          );
        })}
      </div>
      {!value && <div className="text-xs text-amber-800 font-medium bg-amber-50 border border-amber-300 rounded-md px-3 py-2" data-testid="entry-group-hint">Önce veri giriş türünü seçin — 1. Adım (proje seçimi) ve diğer alanlar seçimden sonra açılır.</div>}
    </div>
  );
}
